import { CurrencyCodeType } from '@/types/currency';

import { CURRENCY_SYMBOL_DATA_MAP } from './constants';

export const formatNumberToCurrency = (
  amount: number,
  currency?: CurrencyCodeType,
  displayCurrencySymbol?: boolean
): string => {
  if (!currency) return String(amount);

  const currencyCode = currency.toUpperCase() as CurrencyCodeType;
  const currencySymbolData = CURRENCY_SYMBOL_DATA_MAP[currencyCode];

  const formattedAmount = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currencyCode,
  })
    .formatToParts(amount)
    .map(p => (p.type !== 'literal' && p.type !== 'currency' ? p.value : ''))
    .join('');

  if (displayCurrencySymbol && currencySymbolData && formattedAmount) {
    return currencySymbolData.isPrefix
      ? `${currencySymbolData.symbol}${formattedAmount}`
      : `${formattedAmount} ${currencySymbolData.symbol}`;
  }

  return formattedAmount;
};
